module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-navy-2-601eab7043bf3d1e889302ccc324d90a.webp";